import { IFormField } from '../IForm.types';
import { InputNumberForm } from './InputNumberForm';

export class InputIntegerForm extends InputNumberForm {
  constructor(field: IFormField) {
    super(field);
    this.validate.custom = 'valid = Number.isInteger(Number(input))';
    this.validate.customMessage = 'Number must be of type integer';
  }
}
